import Toastr from "../../../itrust_common/components/Toastr";

const DEFAULT_STATE = {
  loading: false,
  saving: false,
  locations: [],
  catalogItems: [],
  mappings: []
};

let changes = null;

export default function catalogMappingReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response);

  switch (action.type) {
    case 'VISION_WEB_SETTING_CREATE_PENDING':
    case 'CATALOG_MAPPING_CREATE_PENDING':
    case 'CATALOG_MAPPING_DELETE_PENDING':
    case 'FETCH_ALL_TYPE_MAPPING_PENDING':
    case 'FETCH_ALL_TYPE_MAPPING_APPEND_PENDING':

      return {
        ...state,
        loading: true,
        saving: true
      };
    case 'VISION_WEB_SETTING_CREATE_REJECTED':
    case 'CATALOG_MAPPING_CREATE_REJECTED':
    case 'CATALOG_MAPPING_DELETE_REJECTED':
    case 'FETCH_ALL_TYPE_MAPPING_REJECTED':
    case 'FETCH_ALL_TYPE_MAPPING_APPEND_REJECTED':
      if (response?.data) {
        Toastr.handleShow(
          response.data.success,
          response.data.error,
          response.data.status_code
        );
      }

      changes = {
        loading: false,
        saving: false
      };

      return {
        ...state,
        ...changes
      };
    case 'VISION_WEB_SETTING_CREATE_FULFILLED':
    case 'CATALOG_MAPPING_CREATE_FULFILLED':
    case 'CATALOG_MAPPING_DELETE_FULFILLED':
      Toastr.handleShow(
        true,
        response?.meta?.message,
        201
      );

      changes = {
        loading: false,
        saving: false
      };

      return {
        ...state,
        ...changes
      };

    case 'VISION_WEB_LOCATIONS_LOAD':
      return {
        ...state,
        locations: action.payload
      };

    case 'FETCH_ALL_TYPE_MAPPING_FULFILLED':
      changes = {
        loading: false,
        saving: false,
        catalogItems: action.payload.data || []
      };

      return {
        ...state,
        ...changes
      };

    case 'FETCH_ALL_TYPE_MAPPING_APPEND_FULFILLED': {
      const existingItems = state.catalogItems?.catalog_items || [];
      const newItems = action.payload.data?.catalog_items || [];
      const updatedCatalogItems = {
        ...(state.catalogItems || {}),
        catalog_items: [...existingItems, ...newItems],
        meta: action.payload.data?.meta || state.catalogItems?.meta
      };

      changes = {
        loading: false,
        saving: false,
        catalogItems: updatedCatalogItems
      };

      return {
        ...state,
        ...changes
      };
    }

    case 'CATALOG_MAPPINGS_LOAD_FULFILLED':
      return {
        ...state,
        loading: false,
        saving: false,
        mappings: action.payload.data || []
      };

    default:
      return state;
  }
}